import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex items-center justify-center mr-3 size-4 shrink-0 [&_svg]:size-full"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnTooltip"], {
        position: $props.tooltipPosition,
        disabled: !$props.disabled || !$props.disabledTooltip,
        text: $props.disabled ? ($props.disabledTooltip ?? undefined) : undefined
    }, {
        default: _withCtx(() => [
            _createVNode($setup["EnItem"], {
                id: $props.staticId ?? undefined,
                class: _normalizeClass($setup.cn('group p-0 h-8 justify-center text-sm rounded-md transition cursor-pointer', $props.active ? 'bg-en-red-100' : 'hover:bg-en-red-100', $props.disabled ? 'opacity-50 pointer-events-none' : '', $setup.props.class)),
                onClick: $setup.onClick
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(['flex w-full items-center py-1 px-3', $props.active ? 'text-en-red-400' : 'text-foreground group-hover:text-en-red-400'])
                    }, [
                        (_ctx.$slots.icon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _renderSlot(_ctx.$slots, "icon")
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createElementVNode("span", null, [
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ], 2 /* CLASS */)
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["id", "class"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["position", "disabled", "text"]));
}
